// Mortgage estimator utilities.
// Uganda market: bank mortgage rates ~17–22% p.a. Default 18% for 15 years.
// Formula: M = P * r(1+r)^n / ((1+r)^n - 1) where r = monthly rate, n = months.
export const DEFAULT_DOWN_PCT = 20;
export const DEFAULT_TERM_YEARS = 15;
export const DEFAULT_RATE_APR = 18;

export function monthlyPayment({
  price,
  downPct = DEFAULT_DOWN_PCT,
  termYears = DEFAULT_TERM_YEARS,
  rateApr = DEFAULT_RATE_APR,
}) {
  const principal = price * (1 - downPct / 100);
  const n = termYears * 12;
  const r = rateApr / 100 / 12;
  if (r === 0) return principal / n;
  const factor = Math.pow(1 + r, n);
  return (principal * r * factor) / (factor - 1);
}

export function formatUGXShort(n) {
  if (n == null || isNaN(n)) return "—";
  if (n >= 1_000_000_000) return `UGX ${(n / 1_000_000_000).toFixed(2)}B`;
  if (n >= 1_000_000) return `UGX ${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `UGX ${(n / 1_000).toFixed(0)}K`;
  return `UGX ${Math.round(n)}`;
}
